<template>
  <div class="solutionDetail">
    <pageHeader :actNum="2" :bannerShow="false">
      <span slot="address">
        <span class="homeSpan" @click="tarSolution">解决方案</span>
        &nbsp;>&nbsp;{{address}}
      </span>
    </pageHeader>
    <div class="title">{{ showData.title }}</div>
    <div class="content">
      <div
        class="content-body"
        v-for="(item, index) in showData.content"
        :key="index"
      >
        <div class="content-body-title" v-if="item.type == 'title'">
          {{ item.value }}
        </div>
        <div class="content-body-text" v-if="item.type == 'text'">
          {{ item.value }}
        </div>
        <div class="content-body-text2" v-if="item.type == 'text2'">
          {{ item.value }}
        </div>
        <img
          class="content-body-img"
          v-if="item.type == 'img'"
          :src="getIconPath(item.value)"
        />
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import {
  data1,
  data2,
  data3,
  data4,
  data5,
} from "@/components/pageDetail/config/solutionConfig";
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
export default {
  name: "solutionDetail",
  components: {
    pageHeader,
    footPage,
  },
  data() {
    return {
      showData: [],
      address:null
    };
  },
  methods: {
    getIconPath(iconName) {
      return require(`@/assets/img/solution/${iconName}.png`);
    },
    tarSolution() {
      this.$router.push("/solution");
    },
    getAddress(str, length){
    return str.slice(0, length);
    }
  },
  created() {
    if (this.$route.query.type == "1") {
      this.showData = data1;
    } else if (this.$route.query.type == "2") {
      this.showData = data2;
    } else if (this.$route.query.type == "3") {
      this.showData = data3;
    } else if (this.$route.query.type == "4") {
      this.showData = data4;
    } else if (this.$route.query.type == "5") {
      this.showData = data5;
    }
    this.address = this.getAddress(this.showData.title,this.showData.title.length-4)
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 30px;
  text-align: center;
  line-height: 90px;
}
.content {
  padding: 0px 518px 175px 518px;
  &-title {
    font-size: 30px;
    text-align: center;
  }
  &-date {
    margin-top: 10px;
    margin-bottom: 28px;
    font-size: 15px;
    text-align: center;
  }
  &-body {
    &-title {
      font-size: 16px;
      color: #333;
      margin-top: 48px;
      text-align: center;
    }
    &-text {
      margin-top: 20px;
      font-size: 15px;
      line-height: 28px;
      color: #666;
      // text-align: center;
    }
    &-text2 {
      // margin-top: 20px;
      // font-size: 14px;
      // line-height: 20px;
      // color: #666;
      // margin-top: 20px;
      font-size: 15px;
      line-height: 28px;
      color: #666;
      // text-align: center;
    }
    &-img {
      margin-top: 28px;
      // margin-bottom: 28px;
      width: 100%;
    }
  }
}
</style>